import React from 'react';
import EmeraldDialog from 'src/common/components/emerald-dialog/emerald-dialog';
import { SelectList } from 'src/common/components/select-list/select-list';
import { pushEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { ISelectionModal } from 'src/common/interfaces/dtos/ISelectionModal';
import { styles } from './selection-dialog-styles';

const SelectionDialog: React.FC<ISelectionModal> = (props: ISelectionModal): JSX.Element => {
  const classes = styles();
  const { disableBackdropClick, dataTestId } = props;

  return (
    <EmeraldDialog
      open={true}
      fullWidth={true}
      data-testid={dataTestId}
      classes={{
        paper: classes.dialogPaper,
      }}
      disableBackdropClick={disableBackdropClick}
    >
      <SelectList {...props} />
    </EmeraldDialog>
  );
};

export const showEmeraldSelectionDialog = (props: ISelectionModal, modalId?: string): void => {
  pushEmeraldModal(<SelectionDialog {...props} />, undefined, modalId);
};

export default SelectionDialog;
